export const API_URL = "/api/v1/titleappraiser";

// export const API_URL = "http://localhost:8000/api/v1/titleappraiser"
// export const API_URL = "http://ec2-13-223-54-159.compute-1.amazonaws.com:8000/api/v1/titleappraiser"
// export const API_URL = "https://appraisal.truefocusautomation.com/api/v1/titleappraiser"